import styled from "styled-components";

export const Wrapper = styled.section`
  width: 100%;
  padding: 2rem;
  border: 2px solid var(--white);
  box-shadow: 5px 5px 10px var(--white);
  border-radius: 10px;

  .contact-form {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 1fr;
  }
  button {
    height: 40px;
    margin-top: 1rem;
  }

  @media screen and (max-width: 900px) {
    border: 2px solid var(--text-color);
    box-shadow: 5px 5px 10px var(--text-color);
  }
`;
